import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getAllModulesByBrand } from "../api/getAllModulesByBrand";
import { PageModuleDataWithPageId } from "../types";

export const getQueryKey = (brandId: string): string[] => {
  return ["allBrandModules", brandId];
};

export const useAllModulesByBrandQuery = (brandId: string) => {
  return useQuery({
    queryKey: getQueryKey(brandId),
    queryFn: () => getAllModulesByBrand(brandId),
    select: (data) => data,
  });
};

export const getAllModulesByBrandQueryData = (
  brandId: string,
): PageModuleDataWithPageId[] => {
  const data = queryClient.getQueryData<PageModuleDataWithPageId[]>(
    getQueryKey(brandId),
  );

  return data || [];
};

export const setAllModulesByBrandQueryData = (
  brandId: string,
  data: PageModuleDataWithPageId[],
) => {
  queryClient.setQueryData(getQueryKey(brandId), data);
};

export const invalidateAllModulesByBrandQuery = async (brandId: string) => {
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(brandId),
  });
};
